/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ko': {
    width: 612,
    height: 612,
    viewBox: '0 0 612 612',
    data: '<path pid="0" d="M612 36.004L576.521.603 306 270.608 35.478.603 0 36.004l270.522 270.007L0 575.997l35.478 35.4L306 341.411l270.521 269.986 35.479-35.4-270.541-269.986z"/>'
  }
})
